module.exports = __webpack_public_path__ + "assets/img/account.597cb11e.svg";